module.exports = "/virtual-football-league/img/amblems/right/logos/Bournmouth.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Bournmouth.png
// module id = 2162
// module chunks = 4